import { useComments, useCommentsDispatch } from "../../context/CommentsProvider"
import { useSettings } from "../../context/SettingsProvider";

export default function CommentsLoadMore(){

	const settings = useSettings();
	const commentsContext = useComments();
	const commentsDispatch = useCommentsDispatch();

	const classes = ["wp-block-buttons", "is-content-justification-center", "is-layout-flex", "wp-block-buttons-is-layout-flex", "comments--load-more"];
	if(settings.isLoading){
		classes.push("is-loading");
	}

	const onButtonClick = (e) => {
		e.preventDefault();

		commentsDispatch({
			type:'load'
		});
	}

	return (
		<>
			{	commentsContext.count > Object.keys(commentsContext.comments).length &&
				<div className={classes.join(" ")}>
					<div class="wp-block-button">
						<button
							className={settings.isLoading ? "wp-block-button__link wp-element-button comments--btn loading-animation" : "wp-block-button__link wp-element-button comments--btn"}
							onClick={onButtonClick}
							disabled={settings.isLoading ? true : false}
						>Load more</button>
					</div>
				</div>
			}
		</>
	)
}